module.exports = __webpack_public_path__ + "img/ssyx_11.5ba8344e.jpg";